export default "__VITE_ASSET__48cc764c__"